var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"icon",class:{ active: _vm.active }},[_vm._m(0),_vm._v(" "),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cross"},[_c('span'),_vm._v(" "),_c('span')])
}]

export { render, staticRenderFns }